export default {"src":"/_next/static/media/icone-quark.891501df.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};